import dayjs from "dayjs";
import { PropertyDisplayFormat } from "../../Models/PropertyDisplayFormat";
import { stripPhoneNumber } from "./phoneNumberFormatting";

/**
 * Converts an edit value to the proper format for sending to the server
 */
export default function convertValueForSave(value: any, format?: PropertyDisplayFormat): any {
    if (dayjs.isDayjs(value)) {
        return value.utc().toISOString();
    }

    if (format === PropertyDisplayFormat.Currency) {
        if (value === "" || value === null || value === undefined) {
            return null;
        }
        return typeof value === "number" ? value : parseFloat(value);
    }

    if (format === PropertyDisplayFormat.Percent) {
        if (value === "" || value === null || value === undefined) {
            return null;
        }
        const numeric = typeof value === "number" ? value : parseFloat(value);
        return isNaN(numeric) ? null : numeric;
    }

    if (format === PropertyDisplayFormat.Number) {
        if (value === "" || value === null || value === undefined) {
            return null;
        }
        const numeric = typeof value === "number" ? value : parseFloat(value);
        return isNaN(numeric) ? null : numeric;
    }

    if (format === PropertyDisplayFormat.PhoneLink) {
        const digits = stripPhoneNumber(value);
        return digits || null;
    }

    if (format === PropertyDisplayFormat.EmailLink) {
        const email = typeof value === "string" ? value.trim().toLowerCase() : value;
        return email || null;
    }

    return value;
}
